import React, { useEffect, useState } from "react";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";
import { toast } from "react-toastify";
import GridRequests from "../../Components/Grid/GridRequests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faSearch } from "@fortawesome/free-solid-svg-icons";
import SearchRequestModal from "../../Components/Modal/SearchRequestModal";

interface Search {
  dt_inicial: string;
  dt_final: string;
  user_id: number;
}

const PagePedidos: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [searchModal, setSearchModal] = useState<boolean>(false);
  const [date, setDate] = useState<Search>({
    dt_final: '',
    dt_inicial: '',
    user_id: 0,
  });
  const [count, setCount] = useState({
    count: '',
    value: '',
  })
  const [request, setRequest] = useState<any[]>([]);
  const [imprt, setImprt] = useState<any[]>([]);
  const [incomplet, setIncomplet] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<string>("pedidos");

  const handleRequests = () => {
    setLoading(true);
    api
      .get(BackEndRoutes.routes.PEDIDOS.LIST)
      .then((response) => {
        const data = response?.data || [];
        setRequest(data);
        console.log(response)

        const imported = data.filter(
          (item: any) =>
            item.data_importacao &&
            item.data_importacao !== "0000-00-00 00:00:00"
        );
        setImprt(imported);

        const incomplete = data.filter((item: any) => item.flg_concluido != 1);
        setIncomplet(incomplete);
      })
      .catch((error) => {
        console.error("Erro ao carregar pedidos:", error);
        toast.error("Não foi possível carregar a lista de pedidos.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSearch = async () => {
    setLoading(true);
    try {
      // await api.get(BackEndRoutes.routes.PEDIDOS.COUNT + `?dt_inicial=${date.dt_inicial}&dt_final=${date.dt_final}`)
      const queryParams = new URLSearchParams({
        dt_inicial: date.dt_inicial,
        dt_final: date.dt_final
      }).toString();

      // Construa a URL completa
      const url = `${BackEndRoutes?.routes?.PEDIDOS.COUNT}?${queryParams}`;
      await api.get(url).then((response) => {
        setCount({
          count: response.data.original.quantidade.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'),
          value: response.data.original.valor
            .replace(/\D/g, '')
            .replace(/(\d{1,})(\d{2})$/, '$1,$2')
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'),
        })
        toast(`Consulta feita com sucesso`)
      })
    } catch (error) {
      console.error("Erro ao buscar o Pedido", error);
      toast("Não há Pedidos neste periodo")
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    handleRequests();
  }, []);

  return (
    <div className="d-flex flex-column container-fluid">
      <div className="d-flex flex-column card">
        <div className="card-header">
          <ul className="nav nav-tabs card-header-tabs" id="myTab" role="tablist">
            <li className="nav-item outline-black" role="presentation">
              <button
                className={`nav-link ${activeTab === "pedidos" ? "active" : "text-black"}`}
                id="pedidos-tab"
                type="button"
                onClick={() => setActiveTab("pedidos")}
              >
                Pedidos
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "importados" ? "active" : "text-black"}`}
                id="importados-tab"
                type="button"
                onClick={() => setActiveTab("importados")}
              >
                Importados
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "incompletos" ? "active" : "text-black"}`}
                id="incompletos-tab"
                type="button"
                onClick={() => setActiveTab("incompletos")}
              >
                Incompletos
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "search" ? "active" : "text-black"}`}
                id="search-tab"
                type="button"
                onClick={() => setSearchModal(true)}
              >
                <FontAwesomeIcon icon={faSearch} />
              </button>
            </li>
          </ul>
        </div>
        <div className="tab-content mt-3 border border-top-0 rounded-bottom" id="myTabContent">
          {/* Pedidos */}
          <div
            className={`tab-pane fade ${activeTab === "pedidos" ? "show active" : ""}`}
            id="pedidos"
            role="tabpanel"
            aria-labelledby="pedidos-tab"
          >
            <div className="card-body">
              <div className=" d-flex align-items-center gap-2 m-2">
                <FontAwesomeIcon className="text-info fa-lg " icon={faCircle} /> Importados
                <FontAwesomeIcon className="text-warning fa-lg " icon={faCircle} />Incompletos
              </div>
              <GridRequests reload={handleRequests} requests={request} />
            </div>
          </div>

          {/* Importados */}
          <div
            className={`tab-pane fade ${activeTab === "importados" ? "show active" : ""}`}
            id="importados"
            role="tabpanel"
            aria-labelledby="importados-tab"
          >
            <div className="card-body">
              <div className=" d-flex align-items-center gap-2 m-2">
                <FontAwesomeIcon className="text-info fa-lg " icon={faCircle} /> Importados
                <FontAwesomeIcon className="text-warning fa-lg " icon={faCircle} />Incompletos
              </div>
              <GridRequests reload={handleRequests} requests={imprt} />
            </div>
          </div>

          {/* Incompletos */}
          <div
            className={`tab-pane fade ${activeTab === "incompletos" ? "show active" : ""}`}
            id="incompletos"
            role="tabpanel"
            aria-labelledby="incompletos-tab"
          >
            <div className="card-body">
              <div className=" d-flex align-items-center gap-2 m-2">
                <FontAwesomeIcon className="text-info fa-lg " icon={faCircle} /> Importados
                <FontAwesomeIcon className="text-warning fa-lg " icon={faCircle} />Incompletos
              </div>
              <GridRequests reload={handleRequests} requests={incomplet} />
            </div>
          </div>
          <SearchRequestModal
            show={searchModal}
            setDate={setDate}
            count={count}
            onCancel={() => setSearchModal(false)}
            onConfirm={() => handleSearch()}
          />
        </div>
      </div>
    </div>
  );
};

export default PagePedidos;